import PropTypes from "prop-types";
import styled from "styled-components";

import { Placeholder } from "components/Placeholder";
import { Title } from "style/components/Title.styles";

const CYRChartPlaceholderContainer = styled.div`
  .custom-placeholder {
    min-height: ${({ height }) => height};
  }
`;

const AnnualReturnsChartPlaceholder = ({ height }) => {
  return (
    <CYRChartPlaceholderContainer height={height}>
      <Title>Annual Returns</Title>
      <Placeholder className="custom-placeholder" />
    </CYRChartPlaceholderContainer>
  );
};

AnnualReturnsChartPlaceholder.propTypes = {
  height: PropTypes.string,
};

export { AnnualReturnsChartPlaceholder };
